"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylableVariant = void 0;
// TODO extract to function? (why class?)
var StylableVariant = /** @class */ (function () {
    function StylableVariant(sheet) {
        this.sheet = sheet;
    }
    // public getVariants():{bySelector:Record<string, VariantData>, list:VariantData[]} {
    //     const list:[string, string|null][] = [];
    //     const bySelector:Record<string, VariantData> = {};
    //     this.sheet.AST.walkRules(rule => {
    //         const {selector, nodes} = rule;
    //         if(nodes && selector.match(simpleClassMatch)){
    //             if(!bySelector[selector]) {
    //                 let variant = false;
    //                 let extendsVal:string|null = null;
    //                 let node:any; // ToDo: find out way postcss types don't match runtime
    //                 for(node of nodes) {
    //                     if(node.type === 'decl') {
    //                         if(node.prop === '-st-variant') {
    //                             variant = true;
    //                         }
    //                         if(node.prop === '-st-extends') {
    //                             extendsVal = node.value;
    //                         }
    //                     }
    //                 }
    //                 if(variant){
    //                     const variantData:VariantData = [selector, extendsVal];
    //                     list.push(variantData);
    //                     bySelector[selector] = variantData;
    //                 }
    //             } else {
    //                 // for now...
    //                 throw new Error('duplicate variant declaration error: ' + rule.selector);
    //             }
    //         }
    //     });
    //     return {bySelector, list};
    // }
    StylableVariant.prototype.getVariantStyleRules = function (selector) {
        var result = [];
        // const {bySelector, list} = this.getVariants();
        // if(bySelector[selector]){
        this.sheet.walkRules(function (rule) {
            // if(rule.selector.startsWith(selector)){
            if (rule.selector.match(new RegExp("^" + selector + "$|^" + selector + "[:].*$"))) {
                result.push(rule);
            }
        });
        // }
        return result;
    };
    return StylableVariant;
}());
exports.StylableVariant = StylableVariant;
//# sourceMappingURL=stylable-variant.js.map